<template>
  <div class="modal-overlay" @click.self="cerrarModal">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Archivos de {{ nombre_doc }}</h5>
        <button type="button" class="close" @click="cerrarModal"><span>&times;</span></button>
      </div>
      <div class="modal-body">
        <div>
          <span>Subir archivos</span>
          <FilePond
            name="file"
            ref="pond"
            label-idle="Arrastra o haz click aquí para seleccionar archivos"
            :allow-multiple="true"
            :allow-file-type-validation="true"
            :accepted-file-types="tiposPermitidos"
            :file-validate-type-detect-type="detectType"
            :max-file-size="maxSize"
            :max-files="10"
            @addfile="onFileAdd"
            @removefile="onFileRemove"
          />
          <div class="d-flex justify-content-center m-2">
            <button
              class="btn btn-primary btn-animated px-5 py-2"
              @click="subirArchivo"
              v-if="archivos.length > 0"
              :disabled="subiendo"
            >
              Subir
            </button>
          </div>
        </div>
        <div v-if="archivos_pre.length > 0">
          <span>Archivos subidos</span>
          <transition-group name="smooth-bounce" tag="ul" class="list-group">
            <li 
              class="list-group-item d-flex justify-content-between align-items-center"
              v-for="archivo in archivos_pre"
              :key="archivo.id"
            >
              <span>{{ archivo.nombre }}</span>
              <div class="d-flex">
                <div>
                  <button 
                    class="btn btn-sm btn-outline-primary mr-1"
                    @click="descargarArchivo(archivo.url)"
                  >
                    <i class="fa fa-regular fa-eye"></i>
                  </button>
                </div>
                <div>
                  <div v-if="archivosEliminando[archivo.id]" class="spinner-border text-danger" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <button 
                    v-else
                    class="btn btn-sm btn-outline-danger"
                    @click="eliminarArchivo(archivo.id)"
                  >
                    <i class="fa fa-solid fa-trash"></i>
                  </button>
                </div>
              </div>
            </li>

          </transition-group>
        </div>


      </div>
      <div class="modal-footer">
        <div v-if="uploadProgress > 0" class="progress mt-2" style="width: 100%;">
          <div 
            class="progress-bar progress-bar-striped progress-bar-animated" 
            role="progressbar" 
            :style="{ width: uploadProgress + '%' }"
            :aria-valuenow="uploadProgress"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosInstance from '../../services/axiosInstance'
import vueFilePond from 'vue-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';

import 'filepond/dist/filepond.min.css';

const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginFileValidateSize);

export default {
  name: 'ModalFilepond',
  components: { FilePond },
  props: {
    visible: Boolean,
    documentoId: Number,
    nombre_doc: String,
    servicioId: Number,
    index: Number,
    archivos_pre: Array,
  },
  data() {
    return {
      tiposPermitidos: [
        'image/jpeg', 'image/png', 'image/gif', 'video/quicktime',
        'application/pdf',
        'application/zip', 'application/x-zip-compressed', 'multipart/x-zip',
        'application/x-rar-compressed', 'application/vnd.rar', 'application/x-rar',
        'application/octet-stream',
        'application/x-dwg', 'application/x-dxf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'video/mp4',
        'video/quicktime',        // .mov
        'video/x-msvideo',        // .avi
        'video/x-matroska',       // .mkv
        'video/webm',             // .webm
        'video/mpeg',             // .mpeg
        'video/3gpp',             // .3gp
        'video/x-ms-wmv',         // .wmv
      ],
      maxSize: '100MB',
      archivos: [],
      uploadProgress: 0,
      subiendo: false,
      isDeleting: false,
      archivosEliminando: {},
    };
  },
  mounted() {
    const filePondCredits = document.querySelector('.filepond--root .filepond--credits');
    if (filePondCredits) {
      filePondCredits.remove();
    }
  },
  methods: {
    detectType(source, currentType) {
      return new Promise((resolve) => {
        if (!currentType || currentType === 'application/octet-stream') {
          const name = (source.name || '').toLowerCase();
          if (name.endsWith('.dwg')) return resolve('application/x-dwg');
          if (name.endsWith('.dxf')) return resolve('application/x-dxf');
        }
        resolve(currentType);
      });
    },
    cerrarModal() {
      this.$emit('close-modal');
    },
    onFileAdd(error, file) {
      if (!error) {
        this.archivos.push(file.file);
      }
    },
    onFileRemove(error, file) {
      if (!error) {
        // Filtra por nombre de archivo para eliminarlo del arreglo de archivos a subir
        this.archivos = this.archivos.filter(f => f.name !== file.file.name);
      }
    },
    async subirArchivo() {
      if (!this.archivos.length) return;

      try {
        this.subiendo = true;
        const formData = new FormData();
        formData.append('id', this.documentoId);
        formData.append('servicio_id', this.servicioId);
        const nombres = [];

        this.archivos.forEach(file => {
          formData.append('file', file);
          nombres.push(file.name);
        });

        formData.append('nombres', JSON.stringify(nombres));

        const response = await axiosInstance.post('/pam/guardarArchivo', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: (progressEvent) => { //Manejar la barra de progreso
            const porcentaje = Math.round((progressEvent.loaded / progressEvent.total) * 100);
            this.uploadProgress = porcentaje;
          },
        });
        
        this.$emit('archivo-subido', {
          index: this.index,
          documentoId: this.documentoId,
          nota: response.data.nota,
          archivos: response.data.archivos // Los archivos guardados con la respuesta
        });

        console.log('Archivos subidos:', response.data.archivos);
        this.uploadProgress = 0;

        this.flashMessage.success({message: '[ÉXITO]: Archivo(s) subido(s) correctamente.'});
        this.archivos= [];
        this.$refs.pond.removeFiles();
      } catch (error) {
        console.error('Error al subir archivos:', error);
        this.flashMessage.error({
          message: '[ERROR]: Ocurrió un error al subir el archivo(s).'
        });
      }finally {
        this.subiendo = false;
      }
    },
    async eliminarArchivo(idArchivo){
      this.$set(this.archivosEliminando, idArchivo, true);
      try{
        await axiosInstance.delete(`/pam/eliminarArchivo/${idArchivo}`);
        this.$emit('archivo-eliminado', idArchivo);
        this.flashMessage.success({ message: 'Archivo eliminado correctamente' });
      }catch(err){
        console.error(err);
        this.flashMessage.error({ message: 'Error al eliminar el archivo' });
      }
      finally{
        this.$delete(this.archivosEliminando, idArchivo);
      }
    },
    descargarArchivo(nombreArchivo) {
      if (!nombreArchivo) return;

      axiosInstance.post('/pam/vistaPreviaArchivo', {
        file: nombreArchivo
      })
      .then(response => {
        if (response.data) {
          window.open(response.data, '_blank');
        }
      })
      .catch(() => {
        this.flashMessage.error({
          message: '[ERROR]: Ocurrió un error al descargar el archivo.'
        });
      });
    },
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.285); /* Fondo oscuro estilo modal */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050; /* Como los modales de Bootstrap */
}

.modal-content {
  background-color: #fff;
  border-radius: 0.3rem;
  max-width: 600px;
  width: 100%;
  overflow: hidden;
  animation: fadeIn 0.3s ease-out;
}

.modal-header,
.modal-footer {
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
}

.modal-header {
  border-bottom: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-body {
  padding: 1rem;
  max-height: 70vh;
  overflow-y: auto;
}

.close {
  background: none;
  border: none;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
}

@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}

div.filepond--root .filepond--credits {
  display: none !important;
}


/* Transición general */
.smooth-bounce-enter-active {
  transition: transform 0.4s ease-in-out, 
              opacity 0.4s ease-in-out, 
              background-color 2s ease-in-out; /* Duración más larga para que el color verde se desvanezca suave */
}

/* Estado inicial: opaco, escalado, y con fondo verde */
.smooth-bounce-enter {
  opacity: 0;
  transform: scale(0.95) rotate(0deg) translateY(10px);
  background-color: #d4edda; /* Verde claro tipo "success" (puedes ajustar) */
}

/* Estado final: tamaño normal, opacidad 1, fondo normal */
.smooth-bounce-enter-to {
  opacity: 1;
  transform: scale(1) rotate(0deg) translateY(0);
  background-color: transparent; /* Se desvanece al color original */
}

.btn-animated {
  width: 100%;
  animation: pulse 1.5s infinite;
  transition: transform 0.3s ease-in-out;
  font-weight: 500;
  border-radius: 0.5rem;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(13, 110, 253, 0.5);
    transform: scale(1);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(13, 110, 253, 0);
    transform: scale(1.03);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(13, 110, 253, 0);
    transform: scale(1);
  }
}



</style>
